import React from "react";
import { useTranslation } from "react-i18next";

function Charity() {
  const { t } = useTranslation();

  const charity = {
    description: (
      <>
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8834e7896b657f0315e22db59b8eaf28be89bede5fe5fcc5df53826ebea8b9de637fde8e1b4107dd0937f0c3f9154bcc657ef4cdc7ac453ce965af4469ad0e0b23ee08bedf711fac0d8c05af542b62debbb110b651d4cb9925d4faa0f050ad6fdfb4fac19139176deca6e22a9e60e94ebf9adf8d71e009e14f95/file-1750387738889.JPG"
        />
        <br />
        <p className="app-animation-translate-start text-justify">
          {t("charityParagraph1")}
        </p>
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5fe6cf949fbe17d717dcd8796a19804e03f0b7c3384ef0c4ee4bae884b1c30cfc122dd6fb28b69bb89b8441f28acc2d842e9796e1733267e24dab3c9c869d064b9f017b4a210394ad27189f804b9ed1f1e9763758db33ef09cfcf38899022effc28f971a7b0ab40164c9e5f6115e162ee8d71724f3d3b3be065d/file-1750387781182.JPG"
        />
        <br />
        <p className="app-animation-translate-start text-justify">
          {t("charityParagraph2")}
        </p>
        <ol className="list-decimal app-animation-translate-start">
          <li>{t("charityParagraph2List1")}</li>
          <li>{t("charityParagraph2List2")}</li>
          <li>{t("charityParagraph2List3")}</li>
        </ol>
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1a6a7e0dca472b1a23f8b053a056e985e318d642b4df24d92789ef6c3e5d3263702afd7827a0ce7cc900f3f07e0d6fbb3619da5943835e26b31aa50fe36fcac5a2b0c3668c83386d49b85fdd8e6bbda74757070c2f3e70c97e85c0f48fe8a47f6cad50230326492a8281f2e1cc048f58153534cb9e04423d3a56/file-1750387802930.jpg"
        />
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/98aa93366eebd32bb990d5024b15086a72aaed239e8295b7247c1c924b015936be01964543d21f4076d681c5d4f4d8d605ca982530324e59d395611662f2b3bade2e73e8431e4e0f4318fee07abdac43d9198ecba1a5377d45b0cf86bb25d8d0dfc3e5e1438d29b93aef0023f3d8eed3a37d0a20a181b536cacb/file-1750387820487.jpg"
        />
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4d330c92496618ae5047f5c22d976ca47fc708cfa04828c4bcbbc1a7fba279f635f44053760b3ad55d96e8e4a83d50b3f712405d6f7a82264b6721382bd8f26c25224a6430663eb2853940b1cc1f83cbaf41013b257239a75edf3d87528d4c9173969e4c400c0a59ce7e77277e3ba2df90d8e5eded8f10bfb7ab/file-1750387838813.jpg"
        />
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/fcccbd90090ddaa27483941849358a6812904323ef4f7760fbac0c6aeea33cfc05cc0449831e2fb9a8bf8f2a1ec28d6afdc0fa8d410e663c9bc94542f4cef8008a809bebdea95a1e9922b59e935cc3ef788d79d001574a3b90ad60305717e0b49b2b4072dcb24094b626a368945d621e4e468d495f59609b6d51/file-1750388181052.jpg"
        />
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/d137ce8cb4fe5855c0c22c649373f7d24e6faa485d3e0986c758cea1f716475f817f36b96667f79f7cbc0a0d621a6794be87709556f6a00af042b6d71de90ff0f9becc701cdecc332e25b43c6d8183b9162f6877ee4161de917ed19b9dda8a7482675ef96c2653ed4399c90aac85b1ae6ee4b45141790b94cdef/file-1750387889859.jpg"
        />
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4a8ec9f3aa568c1e4667fcb70c7aa582fb2ffd7bb31a47cd2c8fc152901c48d3200c20d72c5d196579e4a2232207e5016f235431d41e580c55fb96dddef0188f03657b1d47275e06c3b29ae127325aeb4025f9502de47058fa5e2343dedfa09412e3fc0f674a36d3bf91df1383409242fe4687a88ae65e91e9ef/file-1750387940779.jpg"
        />
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/751c28db9ee1dbdcfbbc00fa2cab42e84b3ee99066c155c1a96354084b259d6953d52f7717dd630399700772d156aa36638d2acd51e5a38a5555cc82fc14e1548289cb49d877e4093601bee201c46f6de32326184c41cd3ef571158b376e6503b02c4718e40de89dab94442dcbf359458ca83dc36a5320f8b4c1/file-1750387960998.jpg"
        />
        <br />
        <img
          className="app-animation-translate-start mx-auto"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/11a050d776aaf5aab010d63654598503942c94085d933b5db4fe16a16ce15a3458c2e1d1a4787da356430796cbbacbbabe43214f2192ce94fd48f30b42eadcbb32150bb4a7ecc50e9c029c5e99c40e8de7205f4c4a08fd91f48373f4e54f9439751f5b33a5d11f56a8746df28fb66c05810ceba4e39a85ce11fd/file-1750387979997.jpg"
        />
      </>
    ),
  };

  return (
    <div>
      <section>
        <div className="relative">
          <img
            src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5d6260b8cfe0d87c4a84f3a5be2650499d800596cfce422c1df4d6ad7ef66ac73e72223a02bc359af82907bc4962a5bde782b98cf6f04acd5b072181c840dee2e83264308a41794bba2f65554c8c1370a8beb05e7e4ade2120a9cbc270fb612404aad78654ef72d443bbe9abdcef9080e234b5b041345fd706c0/file-1751858972759.JPG"
            alt="main"
            className="w-full max-h-40 sm:max-h-60 object-cover object-center"
          />
          <div className="absolute top-0 bottom-0 left-0 right-0 bg-black/60 text-white">
            <div className="app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8">
              <p className="text-2xl md:text-3xl/[3rem] lg:text-4xl/[3rem] max-w-md lg:max-w-xl px-8 font-bold text-center app-animation-translate-start">
                {t("charityBannerText")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="app-main-container space-y-4">
          <p className="text-xl sm:text-2xl lg:text-4xl uppercase font-bold text-black text-center app-animation-translate-start">
            {t("charityTitle1")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {charity.description}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Charity;
